import { render, staticRenderFns } from "./WhatsappUpload.vue?vue&type=template&id=481038d8&scoped=true"
import script from "./WhatsappUpload.vue?vue&type=script&lang=js"
export * from "./WhatsappUpload.vue?vue&type=script&lang=js"
import style0 from "./WhatsappUpload.vue?vue&type=style&index=0&id=481038d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481038d8",
  null
  
)

export default component.exports